"use client"

import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox"

import { cn } from "@/lib/utils"
import { CheckIcon } from "lucide-react"

function Checkbox({ className, ...props }: CheckboxPrimitive.Root.Props) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer relative flex size-4 shrink-0 items-center justify-center rounded border transition-all outline-none border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-950 hover:border-purple-400 group-hover:border-purple-400 focus-visible:border-purple-500 focus-visible:ring-2 focus-visible:ring-purple-500/20 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-red-500 dark:aria-invalid:border-red-500 data-[checked]:bg-purple-600 data-[checked]:border-purple-600 data-[checked]:text-white dark:data-[checked]:bg-purple-600 dark:data-[checked]:border-purple-600 data-checked:bg-purple-600 data-checked:border-purple-600 data-checked:text-white dark:data-checked:bg-purple-600 dark:data-checked:border-purple-600",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none [&>svg]:size-3"
      >
        <CheckIcon className="stroke-[3]" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
